import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'

function ToDo(){
    const [category, setCategory] = useState('');
  const [priority, setPriority] = useState('Low');
  const [description, setDescription] = useState('');
  const [tasks, setTasks] = useState([]);


  // Fetch tasks from the database when the component mounts
  useEffect(() => {
    fetchTasks();
  }, []);

  // Function to fetch tasks from the database
  const fetchTasks = async () => {
    try {
      const response = await axios.get(baseUrl + "get-todo/");
      setTasks(response.data);
    } catch (error) {
      console.error('Error fetching tasks:', error);
    }
  };

  // Function to handle task input change
const handleCategoryChange = (e) => {
    setCategory(e.target.value);
  };

  // Function to handle priority input change
  const handlePriorityChange = (e) => {
    setPriority(e.target.value);
  };

  // Function to handle description input change
  const handleDescriptionChange = (e) => {
    setDescription(e.target.value);
  };
  // Function to handle task submission
  const handleSubmit = async (e) => {
    e.preventDefault();
     if (!category.trim() || !description.trim()) return;
        const _formData = new FormData();
        _formData.append('category',category);
        _formData.append('priority',priority);
        _formData.append('description',description);
        _formData.append('status', '1');
        _formData.append('addedby', userName);
        _formData.append('ip_add', ipAddress);
          _formData.append('location', userLocation);
    try {
      await axios.post(`${baseUrl}add-todo/`, _formData)
      .then(function (response) {
               if(response.status==200 || response.status==201){
                    Swal.fire({
                        title: 'To Do List Added Successfully',
                        icon: 'success',
                        timer:8001,
                        showConfirmButton: false
                    });
                setTimeout(() => {
                  window.location.href = '/todolist';
                }, 3000);
               }
               });


      setCategory('');
      setPriority('Low');
      setDescription('');
    } catch (error) {
      console.error('Error adding task:', error);
    }
  };

  // Function to handle task deletion
  const handleDelete = async (id) => {
    try {
      await axios.delete(baseUrl+'delete-todo/'+id);
      setTasks(tasks.filter((task) => task.id !== id));
      Swal.fire('success', 'Data has been Deleted');
                setTimeout(() => {
                  window.location.reload();
                }, 3000);

    } catch (error) {
      console.error('Error deleting task:', error);
    }
  };
const columns = [
    { field: 'id', headerName: 'Id', width: 30 },
    { field: 'category', headerName: 'Category', width: 100 },
    { field: 'priority', headerName: 'Priority', width: 100 },
    { field: 'description', headerName: 'Description', width: 400 },
    { field: 'status',
      headerName: 'Status',
      width: 100,
      renderCell: (params) => (
        <span
        style={{
        color: params.value == 1 ? 'red' : 'green',
        display: 'inline-block',
        padding: '3px 5px',
        border: '1px solid #ccc',
        borderRadius: '3px',
        backgroundColor: params.value == 1 ? 'lightcoral' : 'lightgreen'
      }}
        >
          {params.value == 1 ? 'Pending' : 'Completed'}
        </span>
      )
    },
    { field: 'addedby', headerName: 'Added By', width: 100},
    { field: 'edit', headerName: 'Edit',
        renderCell: (params) => (
          <Link to={`/edit-todolist/${params.row.id}`} target="_blank" className="btn btn-warning">
            Edit
          </Link>
      ),
      width: 120 },
      { field: 'delete', headerName: 'Action',
        renderCell: (params) => (
          <button onClick={()=> handleDelete(params.row.id)} className="btn btn-danger btn-sm ms-1">
          <i className="fa-solid fa-trash-can"></i></button>
      ),
      width: 120 },

  ];

  return (
    <section className="container mt-4">
            <div className="row table-responsive">
              <div className='col-md-9 col-12 mb-2'>
                <div className='card'>
    <h3 className=" card-header text-center" style={{color: 'black', backgroundColor: '#e5eaef'}}><i className="fa-solid fa-tasks"
        aria-hidden="true" style={{color: 'red'}}></i>To Do List</h3>
    <div className="card-body">

      <form>
          <div className="mb-3">
          <label htmlFor="category" className="form-label">Category:</label>
          <input
            type="text"
            id="category"
            className="form-control"
            value={category}
            onChange={handleCategoryChange}
            required
          />
        </div>
        <div className="mb-3">
          <label htmlFor="priority" className="form-label">Priority:</label>
          <select id="priority" value={priority} className="form-control"  onChange={handlePriorityChange}>
            <option value="Low">Low</option>
            <option value="High">High</option>
          </select>
        </div>
        <div>
          <label htmlFor="description" className="form-label">Description:</label>
          <textarea
            id="description"
            className="form-control"
            value={description}
            onChange={handleDescriptionChange}
            required
          ></textarea>
        </div>
        <button type="button" onClick={handleSubmit} className="btn btn-primary mt-4">Submit</button>
      </form>
      </div>
    </div>
  </div>
</div>


        <div style={{ height: "100%", width: "100%" }}>
          <DataGrid className="mt-4"
            sx={{
              boxShadow: 4,
              border: 4,
              borderColor: 'primary.light',
              '& .MuiDataGrid-cell:hover': {
                color: 'primary.main',
              },
            }}
            pageSize={28}
            rows={tasks}
            columns={columns}
            components={{
                Toolbar: GridToolbar,
             }}
            autoHeight
          />
        </div>
        </section>
  );
};

export default ToDo;